import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const isAuthenticated = localStorage.getItem('isAuthenticated8Am') === 'true';
  const loginTime = Number(localStorage.getItem('loginTime8Am'));
  const TIMEOUT_DURATION = 30 * 60 * 1000; // 30 minutes in milliseconds

  if (isAuthenticated && Date.now() - loginTime > TIMEOUT_DURATION) {
    // Session timeout
    localStorage.removeItem('isAuthenticated8Am');
    localStorage.removeItem('loginTime8Am');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isAuthenticated) {
    localStorage.setItem('redirectUrl', location.pathname);
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Update login time on each route change to track user activity
  localStorage.setItem('loginTime8Am', Date.now().toString());
  return children;
};

export default ProtectedRoute;